<li>
    <div class="col">
        <div class="row align-items-center mb-2">
            <div class="col-12">
                <h5>
                    {{
                        supplierBasket.supplier.name
                            | supplierDisplayName: supplierBasket.supplier.supplierNumber
                    }}
                </h5>
            </div>
        </div>
        <!-- Ansprechpartner first so the opened multiselect dropdown has room to render below it -->
        <div class="row d-flex align-items-center">
            <div class="col-xl-2 col-lg-2 col-md-4 col-sm-12 col-12">
                <span>{{ 'Ansprechpartner' | translate }}:</span>
            </div>
            <div class="col-xl-10 col-lg-10 col-md-8 col-sm-12 col-12">
                @if (isEditableStep) {
                    <div>
                        <!-- Single contact renders as plain text only once the auto-select is stored;
                             if it failed, fall through to the multiselect so the user can recover
                             (UC_BA_1021, fail-closed gate would otherwise block without a control). -->
                        @if (
                            supplierBasket?.supplierContactsDropdown &&
                            supplierBasket?.supplierContactsDropdown?.length === 1 &&
                            supplierBasket?.supplierContacts?.length > 0
                        ) {
                            @let onlyContact = supplierBasket.supplierContactsDropdown[0];
                            <div>
                                {{ onlyContact.contact.firstName }} {{ onlyContact.contact.surName }}
                                @if (onlyContact.email) {
                                    ({{ onlyContact.email }})
                                }
                                @if (onlyContact.isStandard) {
                                    <em
                                        class="fa-solid fa-star ms-1"
                                        data-testid="standard-contact-star"
                                        role="img"
                                        [title]="'Standard für diesen Buchungskreis' | translate"
                                        [attr.aria-label]="'Standard für diesen Buchungskreis' | translate"
                                    ></em>
                                }
                            </div>
                        }
                        @if (
                            supplierBasket?.supplierContactsDropdown &&
                            (supplierBasket?.supplierContactsDropdown?.length > 1 ||
                                (supplierBasket?.supplierContactsDropdown?.length === 1 &&
                                    !supplierBasket?.supplierContacts?.length))
                        ) {
                            <div>
                                <iim-multiselect
                                    #multiselect
                                    [value]="supplierBasket?.supplierContacts"
                                    [disabled]="disabled"
                                    [required]="required"
                                    [requiredLength]="requiredLength"
                                    [placeholder]="'Suche nach Mitarbeitern' | translate"
                                    [preferences]="preferences"
                                    (valueChange)="updateContactPersonsWithMapping($event, supplierBasket.id)"
                                >
                                    @for (option of contacts; track option) {
                                        <iim-autocomplete-option [value]="option">
                                            {{ option.valueDisplay }}
                                            @if (option.isStandard) {
                                                <em
                                                    class="fa-solid fa-star ms-1"
                                                    data-testid="standard-contact-star"
                                                    role="img"
                                                    [title]="'Standard für diesen Buchungskreis' | translate"
                                                    [attr.aria-label]="'Standard für diesen Buchungskreis' | translate"
                                                ></em>
                                            }
                                        </iim-autocomplete-option>
                                    }
                                </iim-multiselect>
                                @for (
                                    standardContact of selectedStandardContacts;
                                    track standardContact.realSupplierContactId
                                ) {
                                    <div class="small mt-1" data-testid="selected-standard-contact">
                                        <em class="fa-solid fa-star me-1" aria-hidden="true"></em>
                                        {{ 'Standard für diesen Buchungskreis' | translate }}:
                                        {{ standardContact.firstName }} {{ standardContact.surName }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
                @if (!isEditableStep) {
                    <div>
                        @if (
                            supplierBasket?.supplierContactsDropdown &&
                            supplierBasket?.supplierContactsDropdown?.length === 1
                        ) {
                            @let onlyContactReadonly = supplierBasket.supplierContactsDropdown[0];
                            <div>
                                {{ onlyContactReadonly.contact.firstName }} {{ onlyContactReadonly.contact.surName }}
                                @if (onlyContactReadonly.isStandard) {
                                    <em
                                        class="fa-solid fa-star ms-1"
                                        data-testid="standard-contact-star"
                                        role="img"
                                        [title]="'Standard für diesen Buchungskreis' | translate"
                                        [attr.aria-label]="'Standard für diesen Buchungskreis' | translate"
                                    ></em>
                                }
                            </div>
                        }
                        @if (
                            supplierBasket?.supplierContactsDropdown &&
                            supplierBasket?.supplierContactsDropdown?.length > 1
                        ) {
                            <div>
                                @for (x of supplierBasket?.supplierContacts; track x) {
                                    <div>
                                        {{ x.firstName }} {{ x.surName }}
                                        @if (x.isStandard) {
                                            <em
                                                class="fa-solid fa-star ms-1"
                                                data-testid="standard-contact-star"
                                                role="img"
                                                [title]="'Standard für diesen Buchungskreis' | translate"
                                                [attr.aria-label]="'Standard für diesen Buchungskreis' | translate"
                                            ></em>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
        <div class="row d-flex align-items-center">
            @if (env.showCustomTemplate && isEditableStep) {
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-12 col-12">
                    <label>{{ 'Übertragungen' | translate }}:</label>
                </div>
            }
            <div class="col-xl-10 col-lg-10 col-md-8 col-sm-12 col-12">
                <div class="my-3">
                    <client-erp-transmission
                        [(value)]="supplierBasket.transmissionInfo"
                        (valueChange)="updateTransmissionInfo($event, supplierBasket.id)"
                    ></client-erp-transmission>
                </div>
            </div>
        </div>
    </div>
    @if (!isLast) {
        <hr />
    }
</li>
